import React, { useState } from 'react'
import { InputLabel, MenuItem, FormControl, Paper, Typography, Box } from '@mui/material'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { LocationOn, Phone, Email, Language } from '@mui/icons-material'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { IReducer } from '../../interface'
import ReactGA from 'react-ga4'

export default function EducationalPartnersFilter() {
  const educationalPartners = useSelector((state: IReducer) => state.educationalPartnersReducer)
  const [country, setCountry] = useState('')

  const handleChange = (event: SelectChangeEvent) => {
    setCountry(event.target.value as string)
    ReactGA.gtag('event', 'Click Dropdown', {
      elementTitle: event.target.value
    })
  }

  const partnerCountries = educationalPartners
    .map((partner) => {
      return partner.country
    })
    .filter((value) => value !== undefined)
  const countryListFiltered = new Set(partnerCountries)
  const arrayCountries = Array.from(countryListFiltered).sort((a, b) => {
    if (a < b) {
      return -1
    }
    if (a > b) {
      return 1
    }
    return 0
  })

  return (
    <Box mt={8}>
      <Typography>
        <FormattedMessage id='learning.educationalPartners.filterRegion' />
      </Typography>
      <FormControl sx={{ width: '100%', maxWidth: 300, mt: 2, textAlign: 'left' }}>
        <InputLabel>
          <FormattedMessage id='country.country' />
        </InputLabel>
        <Select value={country} label='Country' onChange={handleChange}>
          {arrayCountries.map((country: string, index: number) => {
            return (
              <MenuItem key={index} value={country}>
                {country}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
      <div className='edu-filter-container'>
        {educationalPartners.map((item, key) => {
          return (
            item.country === country && (
              <div className='edu-filter-wrapper' key={key}>
                <Paper className='edu-filter-paper'>
                  <Typography variant='h6' component='h2' gutterBottom>
                    {item.academyName}
                  </Typography>
                  <Typography>
                    <LocationOn />
                    {item.location}
                  </Typography>
                  <Typography>
                    <Email />
                    <a href={'mailto:' + item.email}>{item.email}</a>
                  </Typography>
                  <Typography>
                    <Phone />
                    {item.phone}
                  </Typography>
                  <Typography>
                    <Language />
                    <a href={item.web} target='_blank' rel='noopener noreferrer'>
                      {item.web}
                    </a>
                  </Typography>
                </Paper>
              </div>
            )
          )
        })}
      </div>
    </Box>
  )
}
